import AccessToken from '@/services/auth';

const ACCESS_TOKEN = AccessToken();

export const AUTH = {
	URL: process.env.VUE_APP_API_BASE_URI,
	TOKEN: ACCESS_TOKEN.token
};

export const API_URLS = {
	PRODUCT: '/v1/products',
	PRODUCT_TAG: '/v1/products/tags',
	MODIFIER_TAG: '/v1/modifiers/tags',
	API_MATERIAL: '/v1/inventories',
	API_GOODS_RECCEIPT_SUPPLIER: '/v1/goods-receipts/create/suppliers',
	API_GOODS_RECCEIPT_ITEM: '/v1/goods-receipts/create/items',
	API_STOCK_ADJUSTMENT_ITEM: '/v1/stock-adjustments/create/items',
	API_RAW_MATERIAL_RECIPE_ITEM_INPUT: '/v1/inventory-recipes/item/inputs',
	API_RAW_MATERIAL_RECIPE_ITEM_OUTPUT: '/v1/inventory-recipes/item/outputs',
	API_RAW_MATERIAL_PRODUCTION_RECECIPE: '/v1/inventory-production-batches/recipes',
	API_MODIFIER_ITEM_RECECIPE: '/v1/modifiers/item/recipes',
	API_PRODUCT_ATTRIBUTE: '/v1/products/attributes',
	API_PRODUCT_ITEM_RECECIPE: '/v1/products/recipe',
	API_PRODUCT_MODIFIER: '/v1/products/modifier',
	API_TABLE_ZONE: '/v1/tables/zones'
};
